module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('div', {
    staticClass: "template template--sidebar"
  }, [_c('sidebar', {
    attrs: {
      "user": _vm.user
    }
  }, [_c('p', {
    staticClass: "sidebar__empty small"
  }, [_vm._v("\n        Dit is jouw persoonlijke werkmap, hier komen al jouw gemaakte opdrachten in te staan.\n      ")])]), _c('div', {
    staticClass: "page-wrap"
  }, [_c('div', {
    staticClass: "page-view"
  }, [_c('header', {
    staticClass: "page-header page-header--wide"
  }, [_c('h1', [_vm._v("Hallo " + _vm._s(_vm.user.firstname))]), _c('p', [_vm._v("Welkom bij Kiempunt! De komende tijd krijg je hier verschillende opdrachten voor het vak beeldende vorming te zien. Maar voor het zover is vul je eerst je klascode in, zodat je samen met je klasgenootjes de opdrachten kunt maken.")]), _c('hr')]), _c('div', {
    staticClass: "page-content"
  }, [_vm._m(0), _c('group', {
    attrs: {
      "user": _vm.user
    }
  })], 1), _c('hr', {
    staticClass: "flipped"
  })])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._c;
  return _c('h1', {
    staticClass: "banner"
  }, [_c('span', [_vm._v("Aanmelden bij jouw klas")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5d6306f5","preserveWhitespace":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/Lobby.vue
// module id = GMyW
// module chunks = 1